import { Box, styled, Typography } from "@mui/material";
import { useRecordContext } from "ra-core";
import { FC } from "react";
import { RecPatch } from "~/dataProvider/tools";
import { BackupResponseDto } from "~/gen/api/backup";
import { sanitizeFieldRestProps } from "../field";
import OnDataLock from "~/icons/OnDataLock";


interface BackupTypeFieldProps {
  className?: string,
  label?: string,
  source?: string,
}
const EncryptedTip = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 0,
  left: theme.spacing(3),
  marginLeft: theme.spacing(-3),
  borderTop: `8px solid ${theme.palette.text.disabled}`, 
  borderRight: '8px solid transparent',
  cursor: 'pointer',

  '& + span.MuiTypography-caption': {
    transform: 'matrix(0.8, 0, 0, 0.8, -16, 0)',
  },
  '&:hover + span.MuiTypography-caption': {
    transform: 'matrix(1, 0, 0, 1, 8, 0)',
    marginLeft: theme.spacing(-1),
    '& .more': { display: 'inline' },
  },
}))

const EncryptedTipText = styled(Typography)(({theme}) => ({
  position: 'absolute',
  top: 0,
  transition: 'all 0.1s',
  '& .more' : { display: 'none', float: 'right', color: theme.palette.text.disabled },
}))


const BackupTypeField: FC<BackupTypeFieldProps> = (props) => {
  const { className, ...rest } = props;
  const record = useRecordContext<BackupResponseDto&RecPatch>(props);
  const value = record.backupTypeText;
  const showTip = (record as any).isEncrypted

  return (
    <>
      {showTip &&
        <>
          <EncryptedTip />
          <EncryptedTipText variant="caption">
            <span><OnDataLock transform="scale(0.6)" fontSize="small" color="disabled" /></span>
            <span className="more"> Encrypted</span>
          </EncryptedTipText>
        </>
      }
      <Typography
          component="span"
          variant="body2"
          className={className}
          {...sanitizeFieldRestProps(rest)}
      >
        {value}
      </Typography>
    </>
  );
}

export default BackupTypeField;
